import React, { Component } from 'react'
import Table from 'react-bootstrap/Table'
import { Link } from "react-router-dom"
import moment from 'moment'

import './Logs.css'


const MAX_LENGTH = 80

class Logs extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/dashboard/')),
    }
  }

  renderJSON(data) {
    const json = JSON.stringify(data)
    if (json.length < MAX_LENGTH) {
      return json
    }
    return `${json.substring(0, MAX_LENGTH - 3)}...`
  }

  render() {
    return <div className='TaskEditor'>
      {(!this.props.logs || this.props.logs.length === 0) && <div>
          Cloze Test はまだ実施されていません。
        </div>}
      {this.props.logs && this.props.logs.length > 0 && <div>
        {this.props.maxlogs && `最新 ${this.props.maxlogs} 件`}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>追加日</th>
              {this.props.personal ?
                <th>タスク</th> :
                <th>実施者</th>}
              <th>Type</th>
              <th>JSON</th>
            </tr>
          </thead>
          <tbody>
            {(this.props.logs || []).map(log => <tr key={log.id}>
                <td>{moment(new Date(log.data.finished)).format()}</td>
                {this.props.personal ?
                  <td>{log.taskDataId ?
                    <Link to={`/dashboard/${log.taskDataId}`}>{log.taskTitle}</Link> :
                    <a href={`${this.state.baseURL}?task_id=${log.data.task}&v2=1`} target='_blank' rel='noopener noreferrer'>{log.data.task}</a>}</td> :
                  <td>{log.data.user}</td>}
                <td>{log.data.type}</td>
                <td>{this.renderJSON(log.data.data)}</td>
              </tr>)}
          </tbody>
        </Table>
      </div>}
    </div>
  }
}

export default Logs;
